<mat-accordion class="headers-align" *ngIf="!isLoading">
	<mat-expansion-panel hideToggle>
		<mat-expansion-panel-header>
			<mat-panel-title class="danger italic">
				Past Edits ({{trackingHistory.length}})
			</mat-panel-title>
			<mat-panel-description>
				<mat-icon>history</mat-icon>
			</mat-panel-description>
		</mat-expansion-panel-header>

		<div class="margin-top-sm table-responsive scrollable-500">
			<mat-table [dataSource]="tableDataSource" class="mat-elevation-z1" matSort>

				<ng-container matColumnDef="CHANGED_DATE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Date Modified </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.CHANGED_DATE
						| simpleDateTime: 'MM/dd/YYYY @ h:mm a'}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="CHANGED_BY">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Modified By </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.CHANGED_BY}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="CHANGED_FIELD">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Field </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.CHANGED_FIELD}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="CHANGED_VALUE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Previous Value </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.CHANGED_VALUE}} </mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
			</mat-table>
		</div>
	</mat-expansion-panel>
</mat-accordion>